"use client";
import { Box, GridProps, SimpleGrid, Stack } from "@chakra-ui/react";
import type { ResponsiveValue } from "@chakra-ui/styled-system";
import { Balancer } from "react-wrap-balancer";
import BgImage from "public/shared/darkBgCardbg.png";
import PageLayout from "@/layouts/pageLayout";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import Card, { CardProps } from "../cardsList/card";

type Props = {
  columns?: ResponsiveValue<number>;
  spacing?: GridProps["gridGap"];
  title: string;
  desc?: string;
  list: CardProps[];
  button?: {
    label: string;
    link: string;
  };
  concText?: {
    label: string;
    text: string;
  };
};

const DarkBgCardsFrame = (props: Props) => {
  const {
    columns = { base: 1, sm: 1, md: 3 },
    spacing = { base: 8, md: 16, "2xl": 24 },
    title,
    desc,
    list,
    button,
    concText,
  } = props;
  const headingVariant = useHeadingVariant();

  return (
    <Box
      bgImage={`url(${BgImage.src})`}
      bgSize="cover"
      backgroundPosition="center"
      bgRepeat="no-repeat"
      py={20}
      minH="400px" // Add minimum height to ensure visibility
    >
      <PageLayout spacing={16} marginTop={0}>
        <Stack gap={6}>
          {title && (
            <Heading as="h3" variant={headingVariant} textAlign={"center"} color="white">
              {title}
            </Heading>
          )}
          {desc && (
            <Balancer>
              <Text variant={"label1"} textAlign={"center"} color="white">
                {desc}
              </Text>
            </Balancer>
          )}
        </Stack>
        <SimpleGrid columns={columns} gap={spacing}>
          {list.map((item, index) => (
            <Card key={index} {...item} />
          ))}
        </SimpleGrid>
        {button && (
          <Button
            variant={"outline"}
            onClick={() => scrollToElement(button.link, 120)}
            w="fit-content"
            alignSelf={"center"}
          >
            {button.label}
          </Button>
        )}
        {concText && (
          <Box>
            <Text
              as="span"
              variant={"label1"}
              textAlign={"center"}
              fontWeight={600}
              color="white"
              textDecoration={"underline"}
            >
              {concText.label}
            </Text>{" "}
            <Text as="span" variant={"label1"} textAlign={"center"} color="white">
              : {concText.text}
            </Text>
          </Box>
        )}
      </PageLayout>
    </Box>
  );
};

export default DarkBgCardsFrame;
